<div class="driver-modal">
  <div class="sec_head pad_btm">
    <h2>{{ 'ProvideCommission' | translate }}</h2>
  </div>

  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="commissionHandlingForm"
      (ngSubmit)="onSubmit()">
      <div class="form_group">
        <mat-form-field appearance="fill" class="">
          <input
            matInput
            [min]="0"
            type="number"
            (paste)="preventPaste($event)"
            formControlName="adminCommission"
            [placeholder]="'Commission' | translate"
            class="form_control" />
        </mat-form-field>
        <mat-error
          *ngIf="
            submitted &&
            commissionHandlingForm.get('adminCommission')?.hasError('required')
          ">
          {{ 'Commission' | translate }} {{ 'IsRequired' | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            submitted &&
            commissionHandlingForm.get('adminCommission')?.hasError('max')
          ">
          {{ 'comm100Max' | translate }}
        </mat-error>
      </div>
      
      <div class="submit_btn flex_btn">
        <button class="btnn btn_primary" type="submit">
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
